import Close from "@mui/icons-material/Close";
import Message from "@mui/icons-material/Message";
import { Hidden, Typography } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Slide from "@mui/material/Slide";
import { useTheme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Toolbar from "@mui/material/Toolbar";
import useMediaQuery from "@mui/material/useMediaQuery";
import { API, graphqlOperation } from "aws-amplify";
import React from "react";
import Notification from "../components/Notification";
import { createJobRequestComment } from "../graphql/mutations";

export default function JobRequestInterestDialog(props) {
  const job = props.job;
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [inputErrorMsg, setInputErrorMsg] = React.useState("");
  const [notify, setNotify] = React.useState({
    isOpen: false,
    message: "",
    type: "info",
  });
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const userProfileExists = !!props.userProfile;

  const userProfile = props.userProfile || {};

  async function callLambdaMailer() {
    try {
      const params = {
        firstName: userProfile.firstName,
        lastName: userProfile.lastName,
        company: userProfile.company,
        phone: userProfile.phone,
        email: userProfile.email,
        message: message,
        reciever: job.userMail,
        jobDescription: job.description,
      };

      //console.log("params: ",params);
      const mailer = await API.post("jojooMailerApi", "/mailer", {
        body: { data: params },
      });
      //console.log("mailer", mailer);
      //API.get("jojooMailerApi","/mailer")
      //.then(data => console.log({data}))
      //.catch(err => console.log({err}));
    } catch (err) {
      console.log("Error", err);
    }
  }
  const handleClickOpen = () => {
    if (userProfileExists === false) {
      setNotify({
        isOpen: true,
        message: "För att skicka meddelande måste du fylla i ditt konto",
        type: "error",
      });
      return null;
    }
    setOpen(true);
  };
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const handleSubmit = () => {
    if (!message.trim()) {
      setInputErrorMsg("Vänligen fyll i meddelande");
      return false;
    }
    const promise = post(job, userProfile, message);
    promise.then(() => {
      //alert("Din intresseanmälan har skickats!");
      handleClose();
      // Send email function
      callLambdaMailer();
      setNotify({
        isOpen: true,
        message: "Din intresseanmälan har skickats!",
        type: "success",
      });
    });
    promise.catch((error) => {
      //alert("Något gick fel!");
      setNotify({ isOpen: true, message: "Något gick fel!", type: "error" });
    });
  };

  function handleClose() {
    setOpen(false);
  }

  return (
    <div>
      <Button
        variant="outlined"
        color="primary"
        onClick={handleClickOpen}
        startIcon={<Message />}
      >
        Skicka meddelande
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullScreen={fullScreen}
      >
        {fullScreen && (
          <AppBar style={{ position: "relative", marginBottom: "2vh" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <Close />
              </IconButton>
              <Typography
                variant="h6"
                style={{ marginLeft: "2vh", flex: 1 }}
                component="div"
              >
                {job.company}
              </Typography>

              <Button
                color="inherit"
                autoFocus
                variant="outlined"
                onClick={handleSubmit}
              >
                Skicka
              </Button>
            </Toolbar>
          </AppBar>
        )}
        {!fullScreen && (
          <DialogTitle id="form-dialog-title">
            Skicka meddelande - {job.company}
          </DialogTitle>
        )}

        <DialogContent>
          <Hidden only={["sm", "xs"]}>
            <DialogContentText>
              <div>
                <Typography variant="h6" component="div">
                  Detta skickas till annonsören:
                </Typography>
                <div>
                  {userProfile.firstName} {userProfile.lastName}
                </div>
                <div>{userProfile.company}</div>
                <div>{userProfile.phone}</div>
                <div>{userProfile.email}</div>
              </div>
            </DialogContentText>
          </Hidden>
          <TextField
            onChange={(event) => setMessage(event.target.value)}
            autoFocus
            margin="dense"
            id="name"
            multiline
            variant="outlined"
            rows={8}
            label="Meddelande"
            type="text"
            error={!!inputErrorMsg}
            helperText={inputErrorMsg}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Avbryt
          </Button>
          <Button color="primary" variant="outlined" onClick={handleSubmit}>
            Skicka
          </Button>
        </DialogActions>
      </Dialog>
      <Notification notify={notify} setNotify={setNotify} />
    </div>
  );
}

function post(jobRequest, userProfile, message) {
  const data = {
    input: {
      jobRequestId: jobRequest.id,
      message,
      userId: userProfile.id,
      userFirstName: userProfile.firstName,
      userLastName: userProfile.lastName,
      userEmail: userProfile.email,
      userPhone: userProfile.phone,
      userCompany: userProfile.company,
    },
  };

  const promise = API.graphql(graphqlOperation(createJobRequestComment, data));
  return promise;
}
